<app-header class="sticky-header top-0 z-10"></app-header>
<main class="p-4 main-content mb-20">
  <router-outlet></router-outlet>
</main>
